import { apiClient } from '@repo/shared';

const saveLesson = async(id, lesson) => {
  return await apiClient.post(`/api/lessons/${id}`, lesson);
};

const getLesson = async(id, lessonType) => {
  console.log('In lessonservice.get for id', id);
  const lessons = await apiClient.get(`/api/lessons/${id}?type=${lessonType}`);
  return lessons?.[0];
};

const getLessonsForClass = async classId => {
  const lessons = await apiClient.get(`/api/lessons?classId=${classId}`);
  return lessons;
};

const getLessonsForEvent = async eventId => {
  const lessons = await apiClient.get(`/api/lessons?eventId=${eventId}`);
  return lessons;
};

const markThemeUsed = async (theme, lesson, markForAllClasses, markForAllClassesAtThisSchool) => {
  return await apiClient.post(`/api/lessons/${lesson.id}/themeUsed`, { theme, markForAllClasses, markForAllClassesAtThisSchool });
}

const getThemeUsageForClass = async(classId) => {
  const themeUsage = await apiClient.get(`/api/themes/usage?classId=${classId}`);
  return themeUsage;
}

const LessonService = {
  saveLesson,
  getLesson,
  getLessonsForClass,
  getLessonsForEvent,
  markThemeUsed,
  getThemeUsageForClass,
};

export default LessonService;